import Loader from "../../components/loading/loader";

class PreferenceCentre {
    constructor(DOMelement) {
        try {
            this.el = DOMelement;
            this.submitButton = document.getElementById("preference-form-submit");

            this.loaderEl = document.querySelector(".sd-loading");
            this.loader = new Loader(this.loaderEl);

            this.submitButton.addEventListener("click", this.submitPreferences);
            
        } catch (error) {
            console.log(error);
        }
    }

    submitPreferences = () => {
        if (this.loader) {
            this.loader.show();
            document.querySelector(".preference-loading").style.fontSize = "0px";
            document.getElementById("full-page-overlay").style.display = "block";
        }

        document.getElementById("preference-form-submit").disabled = true;
        document.getElementById("preference-form").submit();
    }
}

export default PreferenceCentre;